/* Own-store bridge for the Shopify theme editor. No customer data or files. */
(() => {
  const storeOrigins = ['https://emberzens.com', 'https://bgjh63-8n.myshopify.com'];
  if (customElements.get('emberzens-member-hub')) return;
  class EmberZensMemberHub extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('iframe');
      this.childOrigin = location.origin;
      this.loading = this.querySelector('[data-hub-loading]');
      if (!this.frame) return;
      this.designMode = this.dataset.designMode === 'true' && window.Shopify?.designMode === true;
      this.loginAttempted = new URLSearchParams(location.search).get('hub_login') === '1';
      this.receive = this.onMessage.bind(this);
      this.sync = this.sendConfig.bind(this);
      window.addEventListener('message', this.receive);
      window.addEventListener('hashchange', this.sync);
      window.addEventListener('resize', this.sync);
      this.frame.addEventListener('load', this.sync);
      this.attributeObserver = new MutationObserver(this.sync);
      this.attributeObserver.observe(this, { attributes: true, attributeFilter: ['data-settings'] });
      this.timeout = window.setTimeout(() => {
        if (!this.loading?.hidden) this.loading.textContent = 'Still loading? Refresh this page, or contact EmberZens support if your library does not appear.';
      }, 20000);
      this.sendConfig();
    }
    disconnectedCallback() {
      window.removeEventListener('message', this.receive);
      window.removeEventListener('hashchange', this.sync);
      window.removeEventListener('resize', this.sync);
      this.frame?.removeEventListener('load', this.sync);
      this.attributeObserver?.disconnect();
      window.clearTimeout(this.timeout);
    }
    view() {
      const value = location.hash.replace(/^#/, '');
      return ['library','downloads','guides','updates','program','support', 'profile','rift','nova','swift','vanta','forge'].includes(value) ? value : 'library';
    }
    sendConfig() {
      let s = {};
      try { s = JSON.parse(this.dataset.settings || '{}'); } catch { /* Safe defaults in child. */ }
      this.frame?.contentWindow?.postMessage({
        type: 'emberzens-hub:config', designMode: this.designMode, loginAttempted: this.loginAttempted,
        previewState: s.preview_state, view: `#${this.view()}`, viewportHeight: window.innerHeight,
        settings: {
          heading: s.heading, description: s.description, buyCta: s.buy_cta,
          vipHeading: s.vip_heading, vipDescription: s.vip_description, vipCta: s.vip_cta,
          showVip: s.show_vip, showOverview: s.show_overview,
          background: s.background, cardBackground: s.card_background, accent: s.accent,
          cardImageHeight: s.card_image_height, cardGap: s.card_gap, contentWidth: s.content_width,
          paddingTop: s.padding_top, paddingBottom: s.padding_bottom
        }
      }, this.childOrigin);
    }
    onMessage(event) {
      if (!storeOrigins.includes(event.origin) || event.source !== this.frame.contentWindow || !event.data || typeof event.data !== 'object') return;
      const d = event.data;
      if (d.type === 'emberzens-hub:ready') {
        this.childOrigin = event.origin;
        if (this.loading) this.loading.hidden = true;
        window.clearTimeout(this.timeout); this.sendConfig();
      } else if (d.type === 'emberzens-hub:height' && typeof d.height === 'number' && Number.isFinite(d.height)) {
        this.frame.style.height = `${Math.max(350, Math.min(12000, Math.ceil(d.height)))}px`;
      } else if (d.type === 'emberzens-hub:navigate' && ['library','downloads','guides','updates','program','support','rift','nova','swift','vanta','forge'].includes(d.view)) {
        // Ignore config echoes and repeated messages. Only an actual section
        // change may reset scroll; mobile viewport/keyboard resize may not.
        if (d.view !== this.view()) {
          history.replaceState(null, '', `${location.pathname}${location.search}#${d.view}`);
          this.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      } else if (d.type === 'emberzens-hub:sign-in' && !this.designMode && !this.loginAttempted) {
        this.loginAttempted = true;
        const returnTo = `/pages/user-hub?hub_login=1#${this.view()}`;
        location.assign(`/customer_authentication/login?return_to=${encodeURIComponent(returnTo)}`);
      } else if (d.type === 'emberzens-hub:open' && !this.designMode && typeof d.path === 'string') {
        const target = new URL(d.path, location.origin);
        if (target.origin === location.origin && /^\/(products\/|account(?:\/|$)|customer_authentication\/login|blogs\/guides|$)/.test(target.pathname)) location.assign(target.href);
      }
    }
  }
  customElements.define('emberzens-member-hub', EmberZensMemberHub);
})();
